(function($) {
    var undercovercolorsResizeTimer = null,
        masonryActive = false,
        masonryOptions = {
            itemSelector: '.post',
            columnWidth: '.grid-sizer',
            percentPosition: true
        };
    $(document).ready(function () {
        var pressSlider =  $('#press-slider'),
            reviewsCarousel = $('#reviews-carousel'),
            blogGrid = $('.blog-grid');

        if(pressSlider.length) {
            $('.press-logos').on('click','a',function (e) {
                e.preventDefault();
                var index = $(this).closest('li').index();
                pressSlider.slick('slickGoTo',index);
            });

            pressSlider.slick({

            });
        }

        if(reviewsCarousel.length) {
            reviewsCarousel.slick({
                slidesToShow: 4,
                responsive: [
                    {
                        breakpoint: 1599,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 1199,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 1,
                            dots: true,
                            arrows: false,
                            adaptiveHeight: true
                        }
                    }
                ]
            });
        }

        if(blogGrid.length) {
            blogGrid.masonry(masonryOptions);
            blogGrid.imagesLoaded().progress(function() {
                blogGrid.masonry('layout');
            });
            masonryActive = true;

            $('.blog-grid .post-image[data-video]').on('click',function(e) {
                e.preventDefault();
                e.stopPropagation();
                var url = $(this).data('video');
                $.magnificPopup.open({
                    type: 'iframe',
                    mainClass: 'mfp-fade video-popup',
                    removalDelay: 160,
                    preloader: false,
                    fixedContentPos: false,
                    items: {
                        src: url
                    }
                });
            });
        }
    });

    function undercoverColorsResize() {
        var blogGrid = $('.blog-grid');
        if(blogGrid.length) {
            if($(window).width() > 767) {
                if(!masonryActive) {
                    blogGrid.masonry(masonryOptions);
                    blogGrid.imagesLoaded().progress(function() {
                        blogGrid.masonry('layout');
                    });
                    masonryActive = true;
                }
            } else {
                if(masonryActive) {
                    blogGrid.masonry('destroy');
                    masonryActive = false;
                }
            }
        }
    }

    $(window).on('resize', function(e) {
        clearTimeout(undercovercolorsResizeTimer);
        undercovercolorsResizeTimer = setTimeout(function() {
            undercoverColorsResize()
        }, 250);
    });
})(jQuery);